import { useTranslation } from 'react-i18next';
import { useBranding } from '~/lib/branding';
import { cn } from '~/lib/utils';

function Footer({ className }: { className?: string }) {
  const { t } = useTranslation('', { keyPrefix: 'footer' });

  const branding = useBranding();

  return (
    <div
      className={cn(
        className,
        'mx-auto flex flex-col gap-6 pb-10 w-full compact:pt-3 compact:pb-[calc(1rem+env(safe-area-inset-bottom))]',
      )}
    >
      <p className="text-[14px] phone:text-[15px] leading-[1.6] text-footer-copy text-center mt-4 compact:text-xs compact:leading-normal compact:mt-0">
        {t('copyright', {
          branding: branding === 'hero' ? 'Hero.io' : 'Chatoshi.ai',
          year: new Date().getFullYear(),
        })}
      </p>
    </div>
  );
}

export default Footer;
